module.exports = __webpack_public_path__ + "img/us(2).2a425dbd.jpg";